import { useSelector } from 'react-redux'

import {
  getCockpitPlanningStatus,
  isCockpitPlanFinished,
  useCockpitPlanningStatuses,
  useManagerCockpitPlanningStatuses,
} from '../../../model/hooks'
import {
  selectCockpitMode,
  selectCockpitOffering,
  selectCockpitPartnerData,
} from '../../../model/selectors'

/** Whether the plan in view is measured full and signed — on the manager cockpit, every plan of
 *  the partners it shows. With nothing raised the tile says the plan is clean only then. */
export const useIsAttentionPlanFinished = () => {
  const isManagerCockpit = useSelector(selectCockpitMode) === 'manager'
  const selectedOffering = useSelector(selectCockpitOffering)
  const partnerData = useSelector(selectCockpitPartnerData)
  const partnerStatuses = useCockpitPlanningStatuses(partnerData[0]?.PartnerId ?? '')
  const managerStatuses = useManagerCockpitPlanningStatuses()

  return isCockpitPlanFinished(
    getCockpitPlanningStatus(isManagerCockpit ? managerStatuses : partnerStatuses, selectedOffering)
  )
}
